import { Component, ViewChild, ElementRef } from "@angular/core";
import { NavController, SegmentButton, LoadingController } from "ionic-angular";
import "rxjs/Rx";
import { AlertController } from "ionic-angular/components/alert/alert-controller";
import {
  AngularFireDatabase,
} from "angularfire2/database";
import { ModalController } from "ionic-angular/components/modal/modal-controller";
import { IonicPage, NavParams, ToastController } from "ionic-angular";
import { Platform } from "ionic-angular/platform/platform";
import * as moment from "moment";
import { img } from "../../pipes/img";
import { Block } from "../../models/block.interface";

@Component({
  selector: "timeline-page",
  templateUrl: "timeline.html"
})
export class TimelinePage {
  user: any;
  users: string[];
  searchQuery: string = "";
  date: any = moment().format();
  time: any = this.date.slice(
    this.date.indexOf("T") + 1,
    this.date.indexOf(":")
  );
  block: Block;
  dates: string[];
  lats: number[];
  longs: number[];

  constructor(
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    private database: AngularFireDatabase,
    public nav: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController
  ) {
    this.block = this.navParams.get("block");
    this.dates = this.block.dates.reverse();
    this.lats = this.block.lats;
    this.longs = this.block.longs;
    this.user = this.navParams.get("user");
    this.users = this.block.users.reverse();
  }

  viewMap(index: number) {
    this.nav.push("ViewmapPage", {
      block: this.block,
      index: index,
      lat: this.lats[this.lats.length-index-1],
      long: this.longs[this.longs.length-index-1]
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/timeline/timeline.ts